import { useApiPrivateRequest } from "../../../shared/hooks/useApi";
import { ExternalAgentShort } from "../models/ExternalAgent";

export const useGetExternalAgents = () => {
  const {
    data: externalAgents,
    call,
    isLoading,
    isFailed,
  } = useApiPrivateRequest<ExternalAgentShort[]>((response) =>
    response.map((data: any) => new ExternalAgentShort(data)),
  );

  const getExternalAgents = async () => {
    await call(`/admin/externalAgents`, "GET");
  };

  return {
    externalAgents,
    getExternalAgents,
    isLoading,
    isFailed,
  };
};
